export default "__VITE_ASSET__133849a4__"